import Taskbar from '../components/Taskbar';
import AnimatedSection from '../components/AnimatedSection';
import TwoColumnLayout from "../components/TwoColumnLayout";
import AppSidebar from "../components/AppSidebar";
 

const Books = () => {
  const images = ["/images/books/book1.jpg", "/images/books/book1.jpg"];
  const captions = [" ", " "];

  return (
    <>
      <Taskbar />
      <TwoColumnLayout sidebar={<AppSidebar />}>
      <div className="max-[942px]:pt-8 min-[942px]:mt-[51px] bg-bg text-text transition-colors duration-500">
          <AnimatedSection images={images} captions={captions} title="Books" />
          <h2 className="text-3xl font-bold text-text mt-40 mb-10">Books loading...</h2>
        </div>
        </TwoColumnLayout>
    </>
  );
};

export default Books;
